import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DictionaryService } from 'app/mdm/terminology/dictionary/services/dictionary.service';
import { TerminologyAttribute } from 'app/mdm/terminology-lib/services/terminology-attribute';
import { AttributeDatatype } from 'app/mdm/terminology-lib/services/attribute-datatype';
import { Dictionary } from 'app/mdm/terminology-lib/services/dictionary';
import { NgForm } from '@angular/forms';

@Component({
  templateUrl: './dictionary-edit.component.html',
})
export class DictionaryEditComponent implements OnInit {
  public isNew = false;
  public attrTypes: Array<string> = AttributeDatatype.values;
  public dictionary: Dictionary;
  public editView: boolean;
  @ViewChild('form') form: NgForm;

  constructor(
    private dictionaryService: DictionaryService,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.editView = true;
      this.dictionaryService.getDictionary(id).subscribe((r) => {
        this.dictionary = r;
      });
    } else {
      this.isNew = true;
      this.dictionary = new Dictionary();
      this.dictionary.names = {};
      this.dictionary.title = {};
      this.dictionary.attributes = [];
    }
  }

  save(): void {
    this.dictionaryService.saveDictionary(this.dictionary).subscribe(() => this.goBack());
  }

  public goBack(): void {
    this.location.back();
  }

  public newAttribute(): TerminologyAttribute {
    const attr = new TerminologyAttribute();
    attr.names = {};
    attr.parameters = {};
    this.dictionary.attributes = [...this.dictionary.attributes, attr];
    attr['expand'] = true;
    return attr;
  }

  public onAttrTypeChange(attr: TerminologyAttribute): void {
    if (attr.datatype === AttributeDatatype.translations) {
      attr.defaultValue = {};
    } else {
      delete attr.defaultValue;
    }
    attr.parameters = {};
  }
}
